import { useTranslation } from 'next-i18next'

import { formatThousands } from '~/utils/helpers'

interface Props {
  totalActivitiesSolvedCount: number
}

export default function ActivitySummary({ totalActivitiesSolvedCount }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  return (
    <div className="w-full font-semibold rounded overflow-hidden shadow-card space-y-3 py-2">
      <p className="text-center">
        <span className="text-purple">{t('multGame.solved')}</span>
      </p>
      <p className="text-center text-h2">{formatThousands(totalActivitiesSolvedCount)}</p>
    </div>
  )
}
